import { render, staticRenderFns } from "./ManageChapterStudio.vue?vue&type=template&id=38846f64&scoped=true&"
import script from "./ManageChapterStudio.vue?vue&type=script&lang=js&"
export * from "./ManageChapterStudio.vue?vue&type=script&lang=js&"
import style0 from "./ManageChapterStudio.vue?vue&type=style&index=0&id=38846f64&lang=scss&scoped=true&"
import style1 from "./ManageChapterStudio.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38846f64",
  null
  
)

export default component.exports